import { Link } from "react-router-dom";
import { Mail, Phone } from "./icons";
import { CONTACT_EMAIL, CONTACT_PHONE, CONTACT_PHONE_TEL } from "../data/contact";
import { useLanguage } from "../context/LanguageContext";

export default function TopBar() {
  const { t } = useLanguage();
  return (
    <div className="hidden min-h-9 items-center justify-center gap-8 border-b border-white/10 bg-accent px-6 py-2 text-xs leading-none text-white/90 md:flex md:px-10 xl:px-16">
      <a
        href={CONTACT_PHONE_TEL}
        className="flex items-center gap-1 transition-colors duration-200 ease-engineered hover:text-white"
      >
        <Phone size={20} className="h-5 w-5 shrink-0" />
        {CONTACT_PHONE}
      </a>
      <span className="h-3 w-px bg-white/30" aria-hidden="true" />
      <a
        href={`mailto:${CONTACT_EMAIL}`}
        className="flex items-center gap-1 transition-colors duration-200 ease-engineered hover:text-white"
      >
        <Mail size={20} className="h-5 w-5 shrink-0" />
        {CONTACT_EMAIL}
      </a>
      <span className="h-3 w-px bg-white/30" aria-hidden="true" />
      <Link to="/contacts" className="group inline-flex items-center gap-1.5 text-white">
        <span className="relative">
          {t("topBarCta")}
          <span className="absolute inset-x-0 -bottom-[3px] h-px origin-left scale-x-0 bg-white transition-transform duration-300 ease-engineered group-hover:scale-x-100" />
        </span>
        <span className="inline-block transition-transform duration-300 ease-engineered group-hover:translate-x-1">
          →
        </span>
      </Link>
    </div>
  );
}
